export class RouteNames {
    static readonly root = '';
    static readonly any = '**';
    static readonly blocked = 'blocked';
    static readonly unsubscribe = ':culture/unsubscribe/:personId/:optoutType';
    static readonly blockAdvice = 'simulationinactive';
    static readonly simulation = 'simulation';
    static readonly yongoSimulation = 'simulation/yongo';
    static readonly simulationLanding = 'landing';
    static readonly simulationBudget = 'budget';
    static readonly needsShowIntro = 'needsIntro';
    static readonly needsConfirmEligibility = 'confirmEligibility';
    static readonly simulationDuration = 'duration';
    static readonly simulationEdit = 'edit';
    static readonly simulationProductView = 'productview';
    static readonly simulationCalculation = 'calculation';
    static readonly simulationProductDetails = 'productdetails';
    static readonly simulationContactDetails = 'contactdetails';
    static readonly simulationUnknownBroker = 'unknownBroker';
    static readonly simulationKnownBroker = 'knownBroker';
    static readonly simulationBrokerInfo = 'brokerInfo';
    static readonly simulationNextSteps = 'nextsteps';
    static readonly simulationDigitalContactDetails = 'digitalcontactdetails';
    static readonly identification = 'identification';
    static readonly simulationDigitalConfirmation = 'digitalconfirmation';
    static readonly simulationBrokerConfirmation = 'brokerconfirmation';
    static readonly simulationWelcomeBack = 'welcomeback';
    static readonly whoAreYou = 'about-you';
    static readonly identificationPersonalDetails = 'persondetails';
    static readonly surveyModule = 'survey';
    static readonly questions = 'question';
    static readonly customerZone = 'customer';
    static readonly customerHome = 'dashboard';
    static readonly authentication = 'authentication';
    static readonly login = 'signIn';
    static readonly ContactAndConsent = 'ContactAndConsent';
    static readonly intro = 'HomeSection1'; // name as per backend
    static readonly needs = 'needs';
    static readonly fatcaBlocked = 'BlockUserFatca'; // name as per backend
    static readonly CrsBlocked = 'BlockUserCRS'; // name as per backend
    static readonly financialcheckintro = 'HomeSection2'; // name as per backend
    static readonly userNeedAnalysisBlock = 'BlockUserNeedAnalysis'; // name as per backend
    static readonly userFinChkConsistencyBlock = 'BlockUserFinancialCheckConsistency'; // name as per backend
    static readonly financialCheckInputAmounts = 'FinancialCheckInputAmounts'; // name as per backend
    static readonly financialCheckUpdateAmounts = 'FinancialCheckUpdateAmounts'; // name as per backend
    static readonly userconsistencyCheck = 'BlockUserCheckConsistency'; // name as per backend
    static readonly areYouSure = 'BlockUserAreYouSureConsistency';
    static readonly consistencyCheckIContinue = 'ConsistencyCheckIContinue'; // name as per backend
    static readonly riskIntro = 'HomeSection3'; // name as per the backend
    static readonly riskAttitudeQuestionOne = 'RiskAttitudeQuestion1'; // name as per backend
    static readonly KnowledgeFrozenPeriodNotOver = 'KnowledgeFrozenPeriodNotOver'; // name as per backend
    static readonly KnowledgeAlreadyPassed = 'KnowledgeAlreadyPassed'; // name as per backend
    static readonly knowledgeIntro = 'HomeSection4'; // name as per backend
    static readonly knowledgeCheckExplanation = 'KnowledgeCheckExplanation'; // name as per backend
    static readonly knowledgeFailed = 'KnowledgeFailed'; // name as per backend
    static readonly knowledgeFrozenPeriod = 'KnowledgeFrozenPeriod'; // name as per backend
    static readonly AdviceIntro = 'HomeSection5'; // name as per backend
    static readonly SustainabilityExplanation = 'SustainabilityExplanationUppie';
    static readonly AdviceRecommendedProducts = 'RecommendedProducts';
    static readonly AdviceThinkOver = 'think-over';
    static readonly AdviceSummary = 'advice-summary';
    static readonly AdviceNoRecommendedProduct = 'no-products';
    static readonly onBoarding = 'onboarding';
    static readonly onBoardingIntro = 'onboarding-intro';
    static readonly beneficiaryclauseintro = 'beneficiary-intro';
    static readonly sepamandate = 'bank-details';
    static readonly onboardingRecap = 'recap';
    static readonly eSign = 'esign';
    static readonly myFund = 'contract';
    static readonly myplan = 'plan';
    static readonly faq = 'faq';
    static readonly messages = 'messages';
    static readonly myprofile = 'profile';
    static readonly iContinue = 'i-continue';
    static readonly editContact = 'editContact';
    static readonly editPayment = 'editPayment';
    static readonly createsepamandate = 'new-sepa';
    static readonly adviceProjection = 'adviceProjection';
    static readonly logout = 'logout';
    static readonly editAddress='editAddress';
    static readonly identificationBlocked='identificationBlocked';
    static readonly BlockDistributionUppie = 'BlockedContext1';
    static readonly BlockDistributionZennie = 'BlockedContext2';
    static readonly BlockDistributionYongo = 'BlockedContext3';
    static readonly SimulationBlocked = 'SimulationBlocked';
    static readonly BlockingScreenLtsProduct = 'BlockingScreenLtsProduct';
    static readonly BlockingScreenMortgageAndLoans = "BlockingScreenMortgageAndLoans";
    static readonly BlockingScreenProfessionalIncome = "BlockingScreenProfessionalIncome";
    static readonly BlockScreenProfessionalIncome = "BlockScreenProfessionalIncome";
    static readonly EligbilityNextStep = "EligbilityNextStep";
    static readonly ExistingContractBlocked = "ExistingContractBlocked";
    static readonly BlockedAge = "BlockedAge";
    static readonly BlockedCountry = "BlockedCountry";
    static readonly BlockedAgeRangeYongo = "BlockedAgeRangeYongo";
    static readonly BlockedCountryRangeYongo = "BlockedCountryRangeYongo";
    static readonly BlockedCountryRangeUppie = "BlockedCountryRangeUppie";
    static readonly InvalidTokenUppie = "InvalidTokenUppie";
    static readonly InvalidTokenZennie = "InvalidTokenZennie";
    static readonly BlockingScreenDuration = "BlockConfirmDurationZennie";
    static readonly BudgetFinancialIntro = "IntroScreenBudget";
    static readonly BlockUserNeedAnalysisZennie = "BlockUserNeedAnalysisZennie";
    static readonly BlockUserNeedAnalysisOther = "BlockUserNeedAnalysisOther";
    static readonly BlockingBudgetConsistency = "BlockingScreenUnder1000revenue";
    static readonly BudgetFinancialConsistencyCheckBlockingScreen = "BudgetFinancialConsistencyCheckBlockingScreen";
    static readonly BudgetCalculation = "BudgetCalculation";
    static readonly FinancialCappingMaxAmountComponent = "MaxAmount";
    static readonly BudgetFrequency = "ChooseFrequency";
    static readonly CatchUpPremium = "DeterminePremium";
    static readonly AmountAndFrequencyScreen = "AmountAndFrequencyScreen";
    static readonly RiskIntroLTS = "IntroScreenRisk";
    static readonly IntroScreenKnowledgeLTS = "IntroScreenKnowledge";
    static readonly IntroScreenAdviceLTS = "AdviceIntroZennie";
    static readonly KnowledgeAlreadyPassedLTS = "KnowledgeAlreadyPassedZennie";
    static readonly KnowledgeFailedLTS = "KnowledgeFailedZennie";
    static readonly BlockUserSustainabilityUppie = "BlockUserSustainabilityUppie";
    static readonly IntroSustainabilityUppie = "IntroSustainabilityUppie";
    static readonly SustainabilityQuestionUppie = "SustainabilitySurveyUppie";
    static readonly yongoLanding = "yongoLanding";
    static readonly BlockUserFatcaYongo = "BlockUserFatcaYongo";
    static readonly BlockUserCRSYongo = "BlockUserCRSYongo";
    static readonly IntroFormulaYongo = "IntroFormulaYongo";
    static readonly IntroChildYongo = "IntroChildYongo";
    static readonly ChildDetailsYongo = "DefineChildYongo";
    static readonly BlockUserNeedsUppieYongo = "BlockUserNeedsUppieYongo";
    static readonly BlockUserNeedsOtherYongo = "BlockUserNeedsOtherYongo";
    static readonly financialAmountYongo = "DefineAmountsYongo";
    static readonly SelectYongoProduct = "SelectYongoProduct";
    static readonly IntroKnowledgeYongo = "IntroKnowledgeYongo";
    static readonly ProductInfoYongo = "ProductInfoYongo";
    static readonly KnowledgeExperienceFeedbackYongo = "KnowledgeExperienceFeedbackYongo";
    static readonly KnowledgeExplanationYongo = "KnowledgeExplanationYongo";
    static readonly OnboardingIntroYongo = "OnboardingIntroYongo";
    static readonly OnboardedYongoLanding = "yongo/onboard";
    static readonly BlockedDueToUsedNiss = "BlockedDueToUsedNiss";
    static readonly BlockedUnmatchedNiss = "BlockedUnmatchedNiss";
    static readonly captureChildDetails = "CaptureChildDetails";
    static readonly OnlinePayment = "OnlinePayment";
    static readonly ErrorScreen = "pageUnresponsive"; // name as per analysis document
    static readonly ComeBackLater = "pageIsDown"; // name as per analysis document
    static readonly RedirectionScreenChild = "BlockChild";
    static readonly RedirectionScreenGeneric = "BlockGeneric";
    static readonly BlockedExpiredIdentification = "BlockedExpiredIdentification";
    static readonly BlockUserNissUCIExists = "BlockUserNissUCIExists";
    static readonly LoginAgnostic = 'login-agnostic';
}
